<div class="main-nav__nav">
  <ng-content></ng-content>
</div>

<portal-main-nav-toggle></portal-main-nav-toggle>
